import type { PlatformOrganizationDetail, PlatformOrganizationSummary } from '@dnx/contracts';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export const orgsQuery = queryOptions({
  queryKey: ['platform', 'orgs'],
  queryFn: () => api<PlatformOrganizationSummary[]>('/platform/organizations'),
  staleTime: 15_000,
});

export const orgQuery = (id: string) => queryOptions({
  queryKey: ['platform', 'orgs', id],
  queryFn: () => api<PlatformOrganizationDetail>(`/platform/organizations/${id}`),
  staleTime: 10_000,
});

export const STATUS_LABEL: Record<string, { label: string; tone: 'success' | 'warning' | 'danger' | 'neutral' }> = {
  active: { label: 'Ativa', tone: 'success' },
  onboarding: { label: 'Implantação', tone: 'warning' },
  suspended: { label: 'Suspensa', tone: 'danger' },
  closed: { label: 'Encerrada', tone: 'neutral' },
};

export const fmtDate = (iso: string | null, withTime = false) => iso
  ? new Intl.DateTimeFormat('pt-BR', { dateStyle: 'medium', ...(withTime ? { timeStyle: 'short' } : {}), timeZone: 'America/Sao_Paulo' }).format(new Date(iso))
  : '—';

export const PLAN_LABEL: Record<string, string> = { pilot: 'Piloto', standard: 'Padrão', network: 'Rede' };
export const planLabel = (p: string) => PLAN_LABEL[p] ?? p;
